import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  signal,
  ChangeDetectorRef,
} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService, IntegrationsService,
  ProjectService,
  TenantService,
} from '../../_services/index';

import {
  ClientContact,
  ClientITProfile,
  Company,
  NetworkDescriptionAndDiagram, Project,
  ProjectControlItem,
  SystemInterconnection,
  SystemRolePrivilege,
  User,
} from '../../_models/index';

import {
  Access,
  ClientContactRole,
  CompanyType,
  DataDirection,
  Role,
} from '../../helpers/index';

import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import * as _ from 'lodash';

import {saveAs as importedSaveAs} from 'file-saver';

import {LoginHelper} from '../../helpers';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {NameAndIdentifier} from '../../_models/nameAndIdentifier';
import {NameAndIdentifierTypeList} from '../../_models/nameAndIdentifierType';
import {SystemLocation} from '../../_models/systemLocation';
import {Device} from '../../_models/device';
import {OtherDesignatedContact} from '../../_models/otherDesignatedContact';
import {SystemSecurityPlanApproval} from '../../_models/systemSecurityPlanApproval';
import {SensitivityCategorization} from '../../_models/sensitivityCategorization';
import {ControlOrigination} from '../../_models/controlOrigination';
import {LeveragedAuthorization} from '../../_models/leveragedAuthorization';
import {PortProtocolService} from '../../_models/portProtocolService';
import {StandartAndGuidance} from '../../_models/standartAndGuidance';
import {LawAndRegulation} from '../../_models/lawAndRegulation';
import {RoleSensitivityLevel} from '../../_models/roleSensitivityLevel';
import {Constants} from '../../helpers/constants';
import {TenantPermissions} from '../../_models/tenantPermissions';
import {SelectControlItemComponent} from '../selectControlItem/select-control-item.component';
import {SelectProjectControlItemComponent} from '../selectProjectControlItem/select-project-control-item.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {InformationType} from "../../_models/informationType";
import {SeparationOfDuty} from "../../_models/separationOfDuty";
import {SeparationOfDutyRole} from "../../_models/separationOfDutyRole";
import {AuthorizedService} from "../../_models/authorizedService";
import {ExternalSystem} from "../../_models/externalSystem";
import {InspectionProfile} from "../../_models/inspectionProfile";
import {InspectionProfileService} from "../../_services/inspectionProfile.service";
import {MessageComponent} from "../message";
import {Policy} from "../../_models/policy";
import {PolicyService} from "../../_services/policy.service";
import {InspectionProfileSet} from "../../_models/inspectionProfileSet";
import {Integration} from "../../_models/integration";
import {EvidenceCentralItem} from "../../_models/evidenceCentralItem";
import {EvidenceCentralService} from "../../_services/evidenceCentral.service";
import {forkJoin} from "rxjs";

@Component({
    standalone: false,
  selector: 'app-inspection-profiles',
  templateUrl: 'inspectionProfiles.component.html',
  styleUrls: ['./inspectionProfiles.component.scss'],
  providers: [DialogService]
})
export class InspectionProfilesComponent implements OnInit {
  loading = false;
  currentUser: User;
  inspectionProfileId: number;
  inspectionProfile: InspectionProfile;
  inspectionProfileSets: any[];
  setOptions: any[];
  displayPolicies = false;
  policies: Policy[] = [];
  setId: number;
  isSetEdit: boolean;
  setName: string;
  newSetName: string;
  projects: Project[] = [];
  integrations: Integration[] = [];
  evidenceCentralItemsMap: any = {};
  policyMarked: any = {};
  policySectionMarked: any = {};

  operators = [
    {
      name: 'Equals',
      operator: 'Equals'
    },
    {
      name: 'Not Equals',
      operator: 'NotEquals'
    },
    {
      name: 'Contains',
      operator: 'Contains'
    },
    {
      name: 'Not Contains',
      operator: 'NotContains'
    },
    {
      name: '>',
      operator: 'Greater'
    },
    {
      name: '<',
      operator: 'Less'
    }
  ];
  constants = Constants;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private inspectionProfileService: InspectionProfileService,
    private policyService: PolicyService,
    private projectService: ProjectService,
    private integrationsService: IntegrationsService,
    private evidenceCentralService: EvidenceCentralService,
    private alertService: AlertService,
  ) {
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return;
    }

    this.projectService.getAll().subscribe(p => this.projects = p);
    this.integrationsService.getAll().subscribe(p => this.integrations = p);

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.loadProfiles();
  }

  loadProfiles() {
    forkJoin([this.policyService.getAllPolicys(),
    this.evidenceCentralService.getAll(),
    this.inspectionProfileService.getAllInspectionProfileSets()])
      .subscribe(
        (results) => {
          this.policies = results[0];
          results[1].forEach(e => this.evidenceCentralItemsMap[e.id] = e.integrationId);
          this.inspectionProfileSets = results[2].map(s => ({
            ...s,
            items: s.inspectionProfiles
          }));
          this.setOptions = [{name: 'New Group', id: 0}, ...this.inspectionProfileSets];
          if (this.inspectionProfileId) {
            this.inspectionProfile = this.inspectionProfileSets.flatMap(g => g.inspectionProfiles).find(p => p.id == this.inspectionProfileId);
          } else {
            this.inspectionProfile = this.inspectionProfileSets.flatMap(g => g.inspectionProfiles)[0];
            this.inspectionProfileId = this.inspectionProfile?.id;
          }
          if (this.inspectionProfile) {
            this.policyMarked = {};
            this.policies.forEach(p => {
              const sections = p.policySections.filter(s => s.evidenceCentralItems.find(e => this.evidenceCentralItemsMap[e.id] === this.inspectionProfileId));
              if (sections.length > 0) {
                this.policyMarked[p.id] = true;
                sections.forEach(s => this.policySectionMarked[s.policySectionId] = true);
              }
            });
          }
          if (this.inspectionProfile) {
            this.policyMarked = {};
            this.policySectionMarked = {};
            this.policies.forEach(p => {
              const sections = p.policySections.filter(s => s.evidenceCentralItems.find(e => this.evidenceCentralItemsMap[e.id] === this.inspectionProfileId));
              if (sections.length > 0) {
                this.policyMarked[p.id] = true;
                sections.forEach(s => this.policySectionMarked[s.policySectionId] = true);
              }
            });
          }
          this.setId = this.inspectionProfile?.inspectionProfileSetId || 0;
        }
      );
  }

  onInspectionProfileChanged(event) {
    this.inspectionProfileId = event.value;
    this.loadProfiles();
  }

  createInspectionProfile() {
    this.inspectionProfileService
      .add({name: 'Inspection Profile'})
      .subscribe((r) => {
        this.inspectionProfileId = r.id;
        this.loadProfiles();
      });
  }

  downloadInspectionProfile() {
    this.inspectionProfileService
      .download(this.inspectionProfile)
      .subscribe(res => {
          importedSaveAs(new Blob([res]), this.inspectionProfile.name + '.txt');
        },
        error => {
          const errorMessage = error.status == 401 ? 'The logged in user does not have access to the file\'s location. ' : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        });

  }

  onDone() {
    this.alertService.clear();
    this.inspectionProfileService.update({...this.inspectionProfile, inspectionProfileSetId: this.setId, setName: this.setId ? this.setName : this.newSetName}).subscribe(
      () => {
        this.alertService.success('Profile Successfully Saved');
        this.loadProfiles();
      },
      (error) => {
        const errorMessage =
          'An error occurred while updating client IT profile.';
        this.alertService.error(errorMessage);
      }
    );
  }

  toggleSetEdit(){
    this.isSetEdit = !this.isSetEdit;
    this.setName = this.inspectionProfileSets.find(s => s.id === this.setId).name;
  }

  removeItProfile() {
    this.inspectionProfileService
      .delete(this.inspectionProfileId)
      .subscribe((data) => {
        this.inspectionProfileId = null;
        this.loadProfiles();
      }, (data) => {
        if (data?.error?.error) {
          let dialogRef = this.dialog.open(MessageComponent, {
            width: '350px',
            data: {
              title: '',
              text: data?.error?.error,
              button: 'Ok',
            },
          });
        }
      });
  }

  deleteSet(id){
    this.inspectionProfileService.deleteInspectionProfileSet(id).subscribe(() => {
      this.loadProfiles();
    });
  }

  uploadExample(e) {
    let attachments = (<any>event.target).files;
    if (attachments.length > 0) {
      let file: File = <File>attachments[0];
      this.inspectionProfileService.parseExample(file).subscribe(c => {
        this.inspectionProfile.conditions = c;
      });
    }
  }

  addToken(html) {
    return html
      ? html.replace(
        /api\/attachments\/file\?/gi,
        'api/attachments/file?token=' +
        LoginHelper.getFileToken() +
        '&'
      )
      : html;
  }
}
